// **  Initial State
const initialState = []
  
  const ModalityReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'UPDATE_MODALITIES':
        return action.data
    //   case 'LOGOUT':
    //     const obj = { ...action }
    //     delete obj.type
    //     return { ...state, userData: {}, ...obj }
      default:
        return state
    }
  }
  
  export default ModalityReducer
  